/*
  The mobile buy bar reveals itself only while the real add-to-cart button is off screen.

  An IntersectionObserver on the real button, rather than a scroll listener: the check runs
  off the main thread when the browser decides, not on every scroll frame. This theme's
  whole performance argument is about main-thread time, and a scroll handler on a product
  page is exactly the kind of thing that erodes it.

  The price is mirrored from the real price element on variant change, because Dawn
  re-renders a fixed list of ids and this bar is not one of them.
*/
if (!customElements.get('atlas-sticky-buy')) {
  customElements.define(
    'atlas-sticky-buy',
    class AtlasStickyBuy extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.watch);
        if (!this.target) return;

        this.observer = new IntersectionObserver(
          ([entry]) => {
            // Only hide while the real button is actually visible. Once it has scrolled
            // past, the bar carries the action.
            this.hidden = entry.isIntersecting;
          },
          // A little margin so the bar does not flicker in and out as the button grazes
          // the edge of the viewport.
          { rootMargin: '-24px 0px -24px 0px' }
        );
        this.observer.observe(this.target);

        // Dawn swaps the price element's innerHTML on variant change. Mirroring it here
        // keeps the bar honest without adding the bar to Dawn's own swap list.
        const price = document.getElementById(`price-${this.target.id.split('-').pop()}`)
          || document.querySelector('.price');
        const mirror = this.querySelector('[data-atlas-stickybuy-price]');
        if (price && mirror) {
          this.priceObserver = new MutationObserver(() => {
            const now = price.querySelector('.price-item--sale, .price-item--regular');
            if (now) mirror.textContent = now.textContent.trim();
          });
          this.priceObserver.observe(price, { childList: true, subtree: true });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.priceObserver?.disconnect();
      }
    }
  );
}
